module.exports = __webpack_public_path__ + "img/bird-14-left.61045e1a.png";